import React, { useState, useEffect } from "react";

type StatusMap = Record<string, number>;
type Props = {
  data?: StatusMap;
  onFilterChange?: (filter: string) => void;
};

const DynamicFilters: React.FC<Props> = ({ data = {}, onFilterChange }) => {
  const [activeTab, setActiveTab] = useState(0);

  const keys = Object.keys(data);
  // const activeKey = keys[activeTab] || "";

  useEffect(() => {
    localStorage.setItem("statusActiveTab", String(activeTab));
  }, [activeTab]);

  const handleClick = (key: string, index: number) => {
    setActiveTab(index);
    onFilterChange?.(key);
  };

  return (
    <div className="bg-neutral-100 rounded-lg">
      <div className="px-2 flex gap-4 border-b-2 border-neutral-200">
        {keys.map((key, i) => (
          <div
            key={key}
            onClick={() => handleClick(key, i)}
            className={`p-3 font-semibold cursor-pointer text-sm capitalize ${i === activeTab ? "border-b-2 border-red-500 text-red-500" : ""
              }`}
          >
            {key} ({data[key]})
          </div>
        ))}
      </div>

      {/* Content */}
      {/*<div className="p-3 font-semibold">
        {data[activeKey] === undefined && "No data available"}
      </div>*/}
    </div>
  );
};

export default DynamicFilters;